// extracted by mini-css-extract-plugin
export var container = "MessageUI-module--container--1yW5V";
export var profile = "MessageUI-module--profile--IaGIB";
export var messageWrap = "MessageUI-module--messageWrap--37FUB";